module.exports = __webpack_public_path__ + "static/media/faqs.5c56d10d.svg";